import { useEffect, useRef, useState } from 'react';
import { elementsMatch } from '../utils/elementUtils';
const INPUT_SELECTOR = 'input, textarea';
function findInputElement(target) {
  var _target$matches, _ref;
  if ((_target$matches = target.matches) !== null && _target$matches !== void 0 && _target$matches.call(target, INPUT_SELECTOR)) {
    return target;
  }
  const input = target.querySelector(INPUT_SELECTOR);
  return (_ref = input) !== null && _ref !== void 0 ? _ref : null;
}
function readBorderStyles(el) {
  const computed = window.getComputedStyle(el);
  return {
    borderWidth: parseFloat(computed.borderTopWidth) || 1,
    borderRadius: parseFloat(computed.borderTopLeftRadius) || 0
  };
}

// Hides an input's border visually while preserving its box-model dimensions,
// so the pulser's animated border can sit in its place without layout shift.
function hideInputBorder(el) {
  const save = prop => ({
    value: el.style.getPropertyValue(prop),
    priority: el.style.getPropertyPriority(prop)
  });
  const saved = {
    borderColor: save('border-color'),
    boxShadow: save('box-shadow'),
    outline: save('outline')
  };
  el.style.setProperty('border-color', 'transparent', 'important');
  el.style.setProperty('box-shadow', 'none', 'important');
  el.style.setProperty('outline', 'none', 'important');
  return () => {
    el.style.setProperty('border-color', saved.borderColor.value, saved.borderColor.priority);
    el.style.setProperty('box-shadow', saved.boxShadow.value, saved.boxShadow.priority);
    el.style.setProperty('outline', saved.outline.value, saved.outline.priority);
  };
}
export function useReplaceTargetBorder({
  enabled,
  targets
}) {
  const prevTargetsRef = useRef([]);
  const restoreFnsRef = useRef([]);
  const [replacedStyles, setReplacedStyles] = useState(null);
  useEffect(() => {
    if (!enabled) {
      restoreFnsRef.current.forEach(fn => fn());
      restoreFnsRef.current = [];
      prevTargetsRef.current = [];
      setReplacedStyles(null);
      return;
    }
    if (elementsMatch(prevTargetsRef.current, targets)) {
      return;
    }
    restoreFnsRef.current.forEach(fn => fn());
    restoreFnsRef.current = [];
    prevTargetsRef.current = targets;
    let firstStyles = null;
    for (const target of targets) {
      const inputEl = findInputElement(target);
      if (!inputEl) continue;
      if (!firstStyles) {
        firstStyles = readBorderStyles(inputEl);
      }
      restoreFnsRef.current.push(hideInputBorder(inputEl));
    }
    setReplacedStyles(firstStyles);
  }, [enabled, targets]);
  useEffect(() => {
    return () => {
      restoreFnsRef.current.forEach(fn => fn());
      restoreFnsRef.current = [];
    };
  }, []);
  return replacedStyles;
}